var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganisationmanagementIocn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.875,
    height: 17,
    viewBox: "48.563 424.5 14.875 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.04 440.438h-.665v-15.141a.797.797 0 0 0-.797-.797H50.422a.797.797 0 0 0-.797.797v15.14h-.664a.398.398 0 0 0-.398.399v.664h14.874v-.664a.398.398 0 0 0-.398-.399Zm-10.227-13.415c0-.22.178-.398.398-.398h1.328c.22 0 .398.178.398.398v1.329c0 .22-.178.398-.398.398h-1.328a.398.398 0 0 1-.398-.398v-1.329Zm0 3.188c0-.22.178-.399.398-.399h1.328c.22 0 .398.179.398.399v1.328c0 .22-.178.399-.398.399h-1.328a.398.398 0 0 1-.398-.399v-1.328Zm1.726 4.914h-1.328a.398.398 0 0 1-.398-.398v-1.329c0-.22.178-.398.398-.398h1.328c.22 0 .398.178.398.398v1.329c0 .22-.178.398-.398.398Zm2.523 5.313h-2.124v-2.79c0-.22.178-.398.398-.398h1.328c.22 0 .398.178.398.398v2.79Zm2.126-5.711c0 .22-.179.398-.399.398h-1.328a.398.398 0 0 1-.398-.398v-1.329c0-.22.178-.398.398-.398h1.328c.22 0 .398.178.398.398v1.329Zm0-3.188c0 .22-.179.399-.399.399h-1.328a.398.398 0 0 1-.398-.399v-1.328c0-.22.178-.399.398-.399h1.328c.22 0 .398.179.398.399v1.328Zm0-3.187c0 .22-.179.398-.399.398h-1.328a.398.398 0 0 1-.398-.398v-1.329c0-.22.178-.398.398-.398h1.328c.22 0 .398.178.398.398v1.329Z",
    fill: "#505050",
    fillRule: "evenodd",
    "data-name": "Icon awesome-building"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisationmanagementIocn);
export default __webpack_public_path__ + "static/media/organisationmanagementIocn.9131293a764bc91bc59ce47bf3ed82e8.svg";
export { ForwardRef as ReactComponent };